import { object, string, bool, array, number, boolean } from 'yup';

import { useLocalization } from 'localization';
import { IAddressDto } from 'api/address/dtos';
import { REGEX } from 'constants/validation/regexes';

export type CopyAssetsSchema = {
  copiedBranch: { label: string; value: string };
  copiedReference: string;
  address: string;
  fullAddress: IAddressDto;
  assetIds: number[];
  isNewCase: boolean;
  selectedValue: string;
  selectedOrderLineId: { label: string; value: string };
};

export const downloadMaterialSchema = () => {
  const { t } = useLocalization();

  return object().shape({
    email: string()
      .email()
      .matches(REGEX.EMAIL, t('validation.mixed.default'))
      .required(t('validation.mixed.required')),
    highQuality: bool(),
    filter: string().required(t('validation.mixed.required')),
  });
};

export const copyAssetsSchema = () => {
  const { t } = useLocalization();

  return object().shape({
    copiedBranch: object().shape({
      label: string().required(t('validation.mixed.required')),
      value: string().required(t('validation.mixed.required')),
    }),

    copiedReference: string().required(t('validation.mixed.required')),
    address: string(),
    fullAddress: object().shape({
      buildingDoor: string(),
      buildingFloor: string(),
      buildingNumber: string(),
      city: string(),
      cityArea: string(),
      country: string(),
      street: string(),
      zip: string(),
    }),
    assetIds: array()
      .of(number().required(t('validation.mixed.required')))
      .default([]),
    selectedValue: string(),
    isNewCase: boolean(),
    selectedOrderLineId: object()
      .shape({
        label: string(),
        value: string(),
      })
      .notRequired(),
  });
};

export const addLocationMaterialSchema = () => {
  const { t } = useLocalization();
  return object().shape({
    caseIds: array()
      .of(object().shape({ label: string(), value: string() }))
      .min(1, t('validation.mixed.required')),
    textSearch: string(),
  });
};

export const saveDocumentsSchema = () => {
  const { t } = useLocalization();
  return object().shape({
    name: string().required().required(t('validation.mixed.required')),
    type: string().required().required(t('validation.mixed.required')),
    url: string().url().required().required(t('validation.mixed.required')),
  });
};

export const saveLinksSchema = () => {
  const { t } = useLocalization();
  return object().shape({
    name: string().required().required(t('validation.mixed.required')),
    url: string().url().required().required(t('validation.mixed.required')),
  });
};
